import MetricDataPointForm from './components/metricDataPointForm'

const Create = () => <MetricDataPointForm />

export default Create
